(function( $ ) {
	'use strict';



	$( document ).ready( function($) {



	}); //END document ready


	/*
	* AJAX functions
	* */



})( jQuery );


